import { ComponentFactory, ComponentFactoryResolver, ComponentRef, Injector, NgModuleRef, Type } from '@angular/core';

import { DateIntervalFieldComponent } from './date-field/date-interval-field.component';
// tslint:disable-next-line:max-line-length
import { DynamicListFieldMultipleSelectsComponent } from './dynamic-list-field/multiple-selects/dynamic-list-field-multiple-selects.component';
import { DynamicListFieldSingleSelectComponent } from './dynamic-list-field/single-select/dynamic-list-field-single-select.component';
import { FilterComponent } from './filter.component';
import { InputFieldComponent } from './input-field/input-field.component';
import { SelectFieldComponent } from './select-field/select-field.component';

export class FilterComponentFactory extends ComponentFactory<any> {
  readonly selector: string;
  readonly componentType: Type<any>;
  readonly ngContentSelectors: string[];
  readonly inputs: {
    propName: string;
    templateName: string;
  }[];
  readonly outputs: {
    propName: string;
    templateName: string;
  }[];

  createComponent(elementType: string, componentFactoryResolver: ComponentFactoryResolver): ComponentFactory<FilterComponent> {
    switch (elementType) {
      case 'input':
        return componentFactoryResolver.resolveComponentFactory<InputFieldComponent>(InputFieldComponent);

      case 'select':
        return componentFactoryResolver.resolveComponentFactory<SelectFieldComponent>(SelectFieldComponent);

      case 'date-interval':
        return componentFactoryResolver.resolveComponentFactory<DateIntervalFieldComponent>(DateIntervalFieldComponent);

      case 'dynamic-list-single-select':
        return componentFactoryResolver
          .resolveComponentFactory<DynamicListFieldSingleSelectComponent>(DynamicListFieldSingleSelectComponent);

      case 'dynamic-list-multiple-selects':
        return componentFactoryResolver
          .resolveComponentFactory<DynamicListFieldMultipleSelectsComponent>(DynamicListFieldMultipleSelectsComponent);

      default:
        return null;
    }
  }

  create(
    injector: Injector,
    projectableNodes?: any[][],
    rootSelectorOrNode?: string | any,
    ngModule?: NgModuleRef<any>): ComponentRef<any> {
    return null;
  }
}
